import { useState } from "react"
import { useConfiguracionEstanciaQuery } from "src/gql/schema"
import PersonasExtraReserva from "src/pages/home/room-detail/Modals/PersonasExtraReserva/PersonasExtraReserva"
import { useReserva } from "src/pages/home/room-detail/hooks/useReserva"
import Detail from "src/shared/components/data-display/Detail/Detail"
import DetailAction from "src/shared/components/data-display/Detail/kit/DetailAction/DetailAction"
import DetailContent from "src/shared/components/data-display/Detail/kit/DetailContent/DetailContent"
import DetailIcon from "src/shared/components/data-display/Detail/kit/DetailIcon/DetailIcon"
import DetailRow from "src/shared/components/data-display/Detail/kit/DetailRow/DetailRow"
import DetailText from "src/shared/components/data-display/Detail/kit/DetailText/DetailText"
import { useProfile } from "src/shared/hooks/useProfile"
import useIsColaboradorActive from "src/shared/hooks/useIsColaboradorActive"
import { RoleNames } from "src/shared/hooks/useAuth"

export const AddPerson = ({ isNoShow }: { isNoShow: boolean }) => {
    const { selectedReservation, handleSetReserva } = useReserva()
    const [visibleAddPerson, setVisibleAddPerson] = useState<boolean>(false)
    const { rolName, hotel_id } = useProfile()
    const { InactiveModal, validateIsColabActive } = useIsColaboradorActive()
    const { data: configEstancia } = useConfiguracionEstanciaQuery({ variables: { hotel_id } })
    const personaExtraEnabled = configEstancia?.configuracion_estancia?.data?.personas_extra ?? true

    const canAddPerson =
        personaExtraEnabled &&
        rolName !== RoleNames.mantenimiento && rolName !== RoleNames.monitoreo &&
        (selectedReservation?.personas_extras || 0) < (selectedReservation?.habitacion?.tipo_habitacion?.personas_extra_max || 0) &&
        !isNoShow

    const numPersonas = selectedReservation?.numero_personas || 0
    const numExtras = selectedReservation?.personas_extras || 0
  
    return (
        <>
            {!!visibleAddPerson && (
                <PersonasExtraReserva
                    onClose={() => setVisibleAddPerson(false)}
                    onConfirmed={() => handleSetReserva({ ...selectedReservation, personas_extras: numExtras + 1 })}
                />
            )}
            <Detail color="white">
                <DetailIcon name="UserParentFill" />
                <DetailContent>
                    <DetailRow>
                        <DetailText type="normal">Ocupación</DetailText>
                        {canAddPerson && (
                            <DetailAction
                                disabled={
                                    !!selectedReservation?.descuento_aplicado ||
                                    !!selectedReservation?.extras?.some((extra) => !!extra?.descuento_aplicado)
                                }
                                onClick={validateIsColabActive(() => setVisibleAddPerson(true))}
                            >
                                Agregar
                            </DetailAction>
                        )}
                    </DetailRow>
                    <DetailRow>
                        <DetailText type="bold">
                            {`${numPersonas} persona${numPersonas !== 1 ? "s" : ""}`}
                        </DetailText>
                    </DetailRow>
                    {numExtras > 0 && (
                        <DetailRow>
                            <DetailText type="normal">
                                {numExtras > 1
                                    ? `+ ${numExtras} personas extra`
                                    : `+ ${numExtras} persona extra`}
                            </DetailText>
                        </DetailRow>
                    )}
                </DetailContent>
            </Detail>
            {InactiveModal}
        </>
    )
}
